// Google Maps implementation of the map adapter interface.
export const createGoogleAdapter = ({ googleMap, googleMapsApi }) => {
    // Engine-neutral { north, south, east, west } -> google.maps.LatLngBounds.
    // Google takes a single numeric padding, so only options.padding is used.
    const fitBoundingBox = ({ north, south, east, west }, options) => {
        if (!googleMap || !googleMapsApi) return Promise.resolve();
        const bounds = new googleMapsApi.LatLngBounds(
            { lat: south, lng: west },
            { lat: north, lng: east },
        );
        return new Promise((resolve) => {
            const listener = googleMapsApi.event.addListenerOnce(googleMap, 'idle', resolve);
            googleMap.fitBounds(bounds, (options && options.padding) != null ? options.padding : 80);
            // Fitting an already-correct viewport fires no 'idle'; don't hang.
            setTimeout(() => {
                googleMapsApi.event.removeListener(listener);
                resolve();
            }, 1000);
        });
    };

    return { fitBoundingBox };
};
